module.exports = __webpack_public_path__ + "img/10.dce8dad9.jpg";